<template>
  <div>
    <el-card class="refresh">
      <div slot="header"
           class="clearfix">
        <span>重命名</span>
      </div>
      <el-form label-width="70px">
        <el-form-item label="新名称">
          <el-input v-model.trim="newName"></el-input>
        </el-form-item>
      </el-form>
      <div class="btns">
        <el-button type="primary" size="mini"
                   @click="submitNewName()">更新</el-button>
        <el-button size="mini" @click="cancle()">取消</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import ApiService from '@/services/API-services'
export default {
  name: 'personRename',
  data() {
    return {
      newName: ''
    }
  },
  props: {
    modalInfo: null
  },
  created() {
    console.log(this.modalInfo)
    this.newName = this.modalInfo.docName
  },
  methods: {
    cancle() {
      this.$store.commit('closeModal', 'personRename')
    },
    submitNewName() {
      if (this.newName === '') {
          this.$message({
            message: '请输入新名称',
            type: 'error'
          })
        return false
      }
      var reg = /[@#$%^&*|!{}:/?"<>[\]]+/g
      if (reg.test(this.newName)) {
        this.$message({
          message: '名称不能包含特殊字符',
          type: 'error'
        })
        return false
      }
      this.changeFile()
    },
    changeFile() {
      ApiService.person_doc.reFileName({
        id: this.modalInfo.id,
        parentID: JSON.parse(localStorage.user).userId,
        fileName: this.newName
      }).then(res => {
        if (res.code === 0) {
          this.handleSuccess()
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      })
    },
    handleSuccess() {
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.$store.commit('reloadFile', Math.random())
      this.$store.commit('closeModal', 'personRename')
    },
    fileConcat(fid, filename) {
      ApiService.doc.fileConcat({
        DID: 0,
        FID: fid,
        glid: '',
        BitNumber: '',
        FileName: filename,
        DocumentCode: this.modalInfo.docCode ? this.modalInfo.docCode: ''
      }).then(res => {
        if(res.code === 0) {
          this.handleSuccess()
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
@import '../../common/css/color.scss';
.refresh {
  width: 575px;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2), 0px 6px 16px 0px rgba(0, 0, 0, 0.32), 0px 3px 6px -4px rgba(0, 0, 0, 0.48) !important;
  .el-card__body {
    padding: 20px;
    .el-form {
      margin: 40px 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/user/personRename.vue